import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Header } from '../index'
import {
  appstorewhitebtn,
  googlewhitebtn,
  brandlogo,
  brandlogowhite,
} from '../../assets'
import styles from './estatehero.module.css'

const Estatehero = () => {
  return (
    <div className={styles.firstFrame}>
      <Header
        brand={brandlogowhite}
        linkStyles={styles.linkStyles}
        mobileBrand={brandlogo}
        brandToggle={brandlogo}
      />

      <div className={styles.firstFramewrapper}></div>
      <div className={styles.estateheaderBody}>
        <div className={styles.headerBodyleft}>
          <div className={styles.usecase}>Estate</div>
          <div className={styles.headerBodylefttextsbuttons}>
            <div className={styles.headerBodylefttexts}>
              <p className={styles.toplefttext}>
                Easy estate management Solutions
              </p>
              <p className={styles.bottomlefttext}>
                CirclePlug makes managing your property easy by giving you a
                simple online tool to manage everything from one place.
              </p>
            </div>
            <div className={styles.platformbuttons}>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://apps.apple.com/ng/app/circleplug/id6462672418`}
              >
                <Image src={appstorewhitebtn} alt='app store button' />
              </Link>
              <Link
                target={'_blank'}
                className={styles.platformbutton}
                href={`https://play.google.com/store/apps/details?id=com.shypes.circlePlug`}
              >
                <Image src={googlewhitebtn} alt='google play button' />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Estatehero
